import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { ParamsClean } from '@/common/decorators/params-clean'
import { getSoftGroupCatalogForSelect } from '@/utils/soft-group-catalog'

export const INSTALLED_GROUP_ID = 9999

export enum BusinessScene {
  softwareDisable = 1,
  watermark = 2,
  genuineSoft = 3,
}

export const BusinessSceneUrl = {
  1: '/softmgr/soft/get',
  2: '/softmgr/soft/custom',
  3: '/authenticsoft/soft/get',
}

const HAS_OTHER_GROUP_BUSINESS = [
  BusinessScene.softwareDisable,
  BusinessScene.genuineSoft,
]

export interface QueryParams {
  soft_name?: string // 软件名称
  page: number // 页码
  limit: number // 每页数量
  soft_group_id?: number // 软件分类id
  useMemory: boolean
  need_filter: 0|1|null
}

export interface Software {
  soft_id: number // 软件id
  soft_name: string // 软件名称
  soft_group_id: number // 软件分类id
  publish_time: number // 发布日期
  soft_version: string // 版本号
  logo_url: string // logo url

  /** 软件进程名 */
  process_name?: string
}

export interface SoftGroup {
  group_id: number
  group_name: string
  group_desc?: string
}

export interface SoftFormat {
  group_id: number
  group_name: string
  group_desc?: string
  software_list: Software[]
}

export interface SoftGroupReq {
  /** 1：软件禁用，2：水印 */
  business_scene: number
}

@Injectable()
export class SoftwareSelectService {
  constructor (private http: Http) {
  }

  formatSoftware (list: Software[]) {
    return list.map((v) => ({
      soft_id: v.process_name,
      ...v
    }))
  }

  getAllSoftware (businessScene) {
    return Promise.all([
      this.getInstalledSoftware({ page: 1, limit: 9999, need_filter: 1 }),
      this.getSoftwareList({ page: 1, limit: 9999 }, businessScene)
    ]).then(response => {
      let [{ list: installedSoft }, { list: groupSoft }] = response
      installedSoft = installedSoft
        .filter(v => !groupSoft.find(k => k.soft_id === v.soft_id))
        .map(v => ({ ...v, soft_group_id: INSTALLED_GROUP_ID }))
      if (!HAS_OTHER_GROUP_BUSINESS.includes(businessScene)) {
        installedSoft = []
      }
      return this.formatSoftware([ ...groupSoft, ...installedSoft ])
    })
  }

  @ParamsClean()
  getInstalledSoftware (params: Partial<QueryParams>) {
    return this.http.post<{ list: Software[] }>('/softmgr/teamsoft/list', params)
  }

  @ParamsClean()
  getSoftwareList (params: Partial<QueryParams>, businessScene) {
    return this.http.post<{
      total: number
      list: Software[]
    }>(BusinessSceneUrl[businessScene], params)
  }

  getSoftGroup (data: SoftGroupReq) {
    return Promise.resolve({
      list: getSoftGroupCatalogForSelect(data.business_scene),
    })
  }
}
